<!-- 头部图片 -->
<template>
  <div style="position:relative ;line-height: 0">
    <img class="headerImg" :src="imgSrc" alt />
    <span class="headerimg-slot">{{headerImgText}}</span>
  </div>
</template>

<script>
export default {
  props: ["headerImgText", "imgSrc"],
  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {}
};
</script>
<style scoped>
.headerImg {
  width: 100%;
  /* height: 300px; */
}
.headerimg-slot {
  position: absolute;
  top: 45%;
  left: 45%;
  font-size: 30px;
  color: #fff;
}
</style>